<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.guard="{item}">
        <div>{{ item.guard ? item.guard.level.string : "0 - 0" }}</div>
      </template>
      <template v-if="!readonly" v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>

    <r-reward-package-config-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RewardPackageConfig} from "@/modules/redactor/models/reward/RewardPackageConfig";
import RRewardPackageConfigDialog from "@/modules/redactor/views/reward-pack/r-reward-package-config-dialog";


export default {
  name: "r-reward-package-config-table",
  components: {RRewardPackageConfigDialog},
  props: {
    title: VueTypes.string.isRequired,
    items: VueTypes.arrayOf(RewardPackageConfig).isRequired,
    readonly: VueTypes.bool.def(false)
  },
  data: () => ({
    headers: [
      {text: 'Name', value: 'name'},
      {text: 'Level', value: 'guard'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    }
  },
  methods: {
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy())
        .then((data) => {
          if (!this.duplicate && this.row_duplicate(data)) {
            this.$alert("Duplicate found!");
          } else {
            this.items.push(data);
          }
        }).catch(() => {
      });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
        .then((data) => {
          if (!this.duplicate && this.row_duplicate(data)) {
            this.$alert("Duplicate found!");
          } else {
            this.items.push(data);
          }
        }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
        .then((data) => {
          const index = this.items.indexOf(item);
          this.items.splice(index, 1)

          if (this.row_duplicate(data)) {
            this.items.splice(index, 0, item);
            this.$alert("Duplicate found!");
          } else {
            this.items.splice(index, 0, data);
          }
        }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    },

    row_duplicate(item) {
      return this.items.find(v => {
        return v.name === item.name;
      });
    },
  }
}
</script>
